<div class="ab-list-item-inner flex w-100 activity-type--mass-action">
  <span class="ab-list-item__icon">
    <span class="ab-fa-stacked--v2">
      <i class="icon fal fa-pen-to-square ab-stacked-icon"></i>
      <i class="icon fal fa-flag-checkered ab-stacked-icon with-shadow--white"></i>
    </span>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">

      <span class="actor">{{item?.user?.name}}</span>
      <span> added a follow-up flag to {{payload.entitiesAffected}} entities </span>
      <span>using bulk edit.</span>

    </div>
    <div class="details">
      <app-clipped-note [text]="payload?.operationData?.note"
                        [showFullText]="showFullText"
                        (showFullTextChange)="setShowFullText($event)">
      </app-clipped-note>
    </div>
  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
